import React from "react";
import "../../App.css";
import idea from "../../img/idea.png";
import value from "../../img/increase.png";
import human from "../../img/love.png";

function Design() {
  return (
    <div
      id="design"
      className="design-section flex flex-col items-start px-5 py-20 gap-y-8 md:px-10 lg:px-20"
    >
      <section className="design-header">
        <h1 className="text-primary text-subhead font-bold md:text-header">
          I use design to...
        </h1>
      </section>

      <section className="design-purpose flex flex-col gap-x-24 gap-y-8 md:flex-row md:justify-between">
        <section className="dedicated-solution design-purpose-content flex items-center md:flex-col">
          <img
            class="purpose-image w-16 mr-4 md:w-24 md:mb-4"
            src={idea}
            alt="idea"
          ></img>
          <section className="flex flex-col gap-y-2 md:text-center">
            <h3 className="text-body text-primary font-semibold">
              Create a dedicated solution.
            </h3>
            <p className="text-small text-primary">
              The world is constantly changing. Someone should be bring a better
              solution for many upcoming problems.
            </p>
          </section>
        </section>
        <section className="delivering-value design-purpose-content flex items-center md:flex-col">
          <img
            class="purpose-image w-16 mr-4 md:w-24 md:mb-4"
            src={value}
            alt="value"
          ></img>
          <section className="flex flex-col gap-y-2 md:text-center">
            <h3 className="text-body text-primary font-semibold">
              Delivering more value.
            </h3>
            <p className="text-small text-primary">
              After all, what’s the point of living if we don’t become a person
              who is useful to others.
            </p>
          </section>
        </section>
        <section className="better-human design-purpose-content flex items-center md:flex-col">
          <img
            class="purpose-image w-16 mr-4 md:w-24 md:mb-4"
            src={human}
            alt="value"
          ></img>
          <section className="flex flex-col gap-y-2 md:text-center">
            <h3 className="text-body text-primary font-semibold">
              Be a better human being.
            </h3>
            <p className="text-small text-primary">
              Constantly exercising my empathy through design helps me to more
              self-improvement.
            </p>
          </section>
        </section>
      </section>
    </div>
  );
}

export default Design;
